module.exports = __webpack_public_path__ + "img/serve7.d895b617.png";